import axios from "axios";

export function getActiveQuestion(id){
    return axios.request({
        method:'GET',
        url:'/api/quiz/getActiveQuestion/'+id
    })
}
export function submitAnswer(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'/api/quiz/submitAnswer'
    })
}